import * as React from "react";
import {
  StyleSheet,
  View,
  Image,
  Text,
  Linking,
  Dimensions,
  TextInput,
  Platform,
} from "react-native";
import ClubList from "../../components/ClubList";
import CharityActions from "../../redux/actions/CharityActions";
import { useSelector } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import { Ionicons } from "@expo/vector-icons";
import BackButton from "../../components/BackButton";

export default function DonateClubsListingScreen() {
  const charitiesLoaded = useSelector((state) => state.charity.charitiesLoaded);
  // var donatedAmount =  useSelector((state) => state.user.userData.balance.amountDonated) || 0;
  // var donatedAmount = Number.parseFloat(donatedAmount);
  if (!charitiesLoaded) {
    CharityActions();
  }
  const [clubName, onChangeSearchText] = React.useState("");
  const charities = useSelector((state) => state.charity.charities);
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar data="5" />
          <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
            <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
              <View style={GlobalStyles.headerTextYellowForweb}>
                <View style={GlobalStyles.backIconContainerForWeb} >
                  <BackButton />
                </View>
                <View>
                  <Text style={GlobalStyles.headingStyle}>Support a Club</Text>
                  <Text style={GlobalStyles.subheaderStyleWeb}>Start by selecting your preferred Club below.</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : (
        <View style={GlobalStyles.fullHeaderBarW}>
          <StatusBar data="BM" />
          <View style={GlobalStyles.headerContainerKL}>
            <View style={[GlobalStyles.headerText]}>
              <Text style={GlobalStyles.headingStyle}>Support a Club</Text>
              <View style={styles.boxSubHeader}>
                <View style={styles.boxSubHeaderColA}>
                  <Text style={GlobalStyles.subheaderStyle}>
                    Start by selecting your preferred Club below.
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      )}
      <View
        style={
          win.width < 768
            ? GlobalStyles.bodyContainerCards
            : GlobalStyles.adjustableBodyContainer
        }
      >
        {/* <View style={GlobalStyles.adjustableBodyContainer}> */}
        <View style={styles.boxContainer}>
          <View style={styles.headerTextB}>
            <View style={styles.optionIconContainer}>
              <TextInput
                style={styles.textInput}
                onChangeText={(text) => onChangeSearchText(text)}
                placeholder={"Search by club name ..."}
                value={clubName}
              />
              <Ionicons
                name={"md-search"}
                size={20}
                color="#998fa2"
                style={styles.iconStyle}
              />
            </View>
            <Text style={styles.bodyStyle}>
              Select your favourite club and donate at no cost to you! Aura
              donates a percentage of the price of all your eligible purchases.
            </Text>
            {Platform.OS === "web" ? (
              <Text
                style={styles.hyperLink}
                onPress={() =>
                  window.open(
                    "https://aura.club/club-nomination-form/",
                    "_blank"
                  )
                }
              >
                Click here to nominate your club!
              </Text>
            ) : (
              <Text
                style={styles.hyperLink}
                onPress={() =>
                  Linking.openURL("https://aura.club/club-nomination-form/")
                }
              >
                Click here to nominate your club!
              </Text>
            )}
          </View>
          <ClubList
            data={charities
              .filter((val) => val.type === 1)
              .filter((val) =>
                val.name.toLowerCase().includes(clubName.toLowerCase())
              )}
          />
        </View>
      </View>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const win = Dimensions.get("window");
var bodyTextSize;
const width = win.width;
if (width < 768) {
  bodyTextSize = 14;
} else if (768 < width && width < 880) {
  bodyTextSize = 18;
} else if (width > 880) {
  bodyTextSize = 18;
}

const styles = StyleSheet.create({
  boxSubHeader: {
    flex: 1,
    flexDirection: "row",
    width: "100%",
    //paddingRight: 20,
    minWidth: 290,
  },

  boxSubHeaderColA: {
    //flex: 4,
    alignItems: "flex-start",
    //padding: 5,
    //width: "100%",
  },

  boxSubHeaderColB: {
    flex: 2,
    //alignItems: "flex-end",
    padding: 5,
    width: "100%",
  },

  hyperLink: {
    fontFamily: "montserrat-bold",
    fontSize: bodyTextSize,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 10,
    color: "#58B7E6"
  },

  fullHeaderBar: {
    borderBottomLeftRadius: 80,
    backgroundColor: "#FFC72C",
  },

  boxContainer: {
    flex: 1,
    backgroundColor: "#FFFF",
    marginLeft: 15,
    marginTop: 15,
    marginRight: 15,
    marginBottom: 0,
    paddingTop: 15,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },

  headerTextB: {
    //backgroundColor: "green",
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 0,
    // maxWidth: "100%",
  },

  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: bodyTextSize,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 10,
  },
  theList: {
    flex: 1,
    alignItems: "center",
  },
  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "center",
    marginBottom: 5,
    color: "#4EBDEF",
  },
  subTextDonated: {
    fontFamily: "montserrat-regular",
    fontSize: 7,
    textAlign: "center",
    color: "#998FA2",
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
      },
    }),
    padding: 10,
    paddingRight: 20,
    paddingLeft: 20,
    height: 40,
    fontSize: 15,
    fontFamily: "montserrat-regular",
    //width: "100%",
    flex: 1,
  },
  optionIconContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: "#DDDDDD",
    borderBottomStartRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    borderBottomRightRadius: 25,
    borderWidth: 1,
    maxWidth: 600,
    alignSelf: "center",
  },
  iconStyle: {
    alignContent: "center",
    paddingRight: 20,
    paddingLeft: 10,
  },
});
